import { StackSpace } from '@grubhubprod/gh-cookbook-react';

interface IDeviceSpacesOptions {
  desktopSpace?: StackSpace;
  tabletSpace?: StackSpace;
  phoneSpace?: StackSpace;
}

export function getDeviceSpaces(
  {
    desktopSpace = 'none',
    tabletSpace = 'none',
    phoneSpace = 'none',
  }: IDeviceSpacesOptions,
  { isDesktop, isPhone }: { isDesktop: boolean; isPhone: boolean }
): StackSpace {
  if (isDesktop) {
    return desktopSpace;
  }

  if (isPhone) {
    return phoneSpace;
  }

  return tabletSpace;
}
